import {EntityResourceIds} from '@dms/api/shared';

/** Record kinds a call can be paired with by hand (`PUT /telephony/calls/{id}/records`). */
export const TELEPHONY_CALL_PAIRING_RESOURCES = [
  EntityResourceIds.interest,
  EntityResourceIds.businessCase,
  EntityResourceIds.serviceCase,
  EntityResourceIds.workshopInterest,
] as const;
